import { Injectable } from '@angular/core';
import { Language } from '@rivethealth/data/translation';
import { BehaviorSubject } from 'rxjs';

// Translation service is provided in the root
// which would provide a single language to the
// entire application.
// Individual components can also choose to provide
// this service and create sub-trees of the app that
// are in different languages.
@Injectable({ providedIn: 'root' })
export class TranslationService {
  readonly lang = new BehaviorSubject<Language>('en');
}
